export default "__VITE_PUBLIC_ASSET__88bb865d__"